import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { getSchemaByServiceId } from '@/common/service/common';
import { transformEntityContainer, transformEntityTypeList } from '@/utils/odata';
import _ from 'lodash';
import { NAME, GETTER, MUTATION, ACTION } from './storeTypeConstant';
export default {
  namespaced: true,
  name: NAME,
  state: () => ({
    // { XXX_SRV: { XXX_ENTITY: { label: '中文名称', properties: [ Property ] } } }
    metadata: {},
    // 自定义metadata定义
    customMetadata: {},
    // 保存odata服务metadata原始数据
    originMetadata: {},
    // 保存odata entity与service之间的关系数据
    entityContainer: {}
  }),
  getters: {
    [GETTER.GET_ORIGIN_METADATA]: state => (serviceId, entityId) => {
      const ret = _.get(state.originMetadata, [serviceId, entityId]);
      return ret;
    },
    [GETTER.GET_CUSTOM_METADATA]: state => (serviceId, entityId) => {
      const ret = _.get(state.customMetadata, [serviceId, entityId]);
      return ret;
    },
    [GETTER.GET_ENTITY_ID_BY_ENTITY_SET]: state => (serviceId, entitySetId) => {
      const {
        entityContainer
      } = state;
      return _.get(entityContainer, [serviceId, 'EntitySet', entitySetId]);
    }
  },
  mutations: {
    /**
     * 保存原始enytityContainer数据
     * @param {*} state
     * @param {*} payload
     */
    updateEntityContainer(state, payload = {}) {
      const s = state;
      const {
        serviceId,
        data
      } = payload;
      const {
        entityContainer
      } = s;
      // ! FIXME 需要考虑缓存的大小，做定期清理
      entityContainer[serviceId] = _.cloneDeep(data);
    },
    /**
     * 通过深拷贝的方式保存原始metadata数据
     * @param {*} state
     * @param {*} payload
     */
    updateOriginMetadata(state, payload = {}) {
      const s = state;
      const {
        serviceId,
        data
      } = payload;
      const currentMetadata = s.originMetadata;
      // ! FIXME 需要考虑缓存的大小，做定期清理
      currentMetadata[serviceId] = _.cloneDeep(data);
    },
    [MUTATION.UPDATE_ENTITY](state, payload = {}) {
      const s = state;
      const {
        serviceId,
        entityId
      } = payload;
      const {
        customMetadata,
        metadata,
        originMetadata
      } = s;
      // ! FIXME 需要考虑缓存的大小，做定期清理
      if (!_.isEmpty(serviceId) && !_.isEmpty(entityId)) {
        const targetService = metadata[serviceId];
        if (targetService === undefined || targetService === null) {
          metadata[serviceId] = {};
        }
        let targetEntity = _.cloneDeep(originMetadata[serviceId][entityId]);
        // merge custom metadata
        const customEntity = _.get(customMetadata, [serviceId, entityId]);
        if (!_.isEmpty(customEntity)) {
          targetEntity = _.merge(targetEntity, customEntity);
        }
        metadata[serviceId][entityId] = targetEntity;
      }
    },
    [MUTATION.CLEAR_ENTITY](state, payload = {}) {
      const s = state;
      // 清空全部Entity缓存
      if (_.isEmpty(payload)) {
        s.metadata = {};
        s.originMetadata = {};
      } else if (!_.isEmpty(payload.entityId) && !_.isEmpty(s.metadata[payload.entityId])) {
        delete s.metadata[payload.entityId];
        delete s.originMetadata[payload.entityId];
      }
    },
    [MUTATION.UPDATE_CUSTOM_ENTITY](state, payload = {}) {
      const s = state;
      const p = payload;
      if (!_.isEmpty(p)) {
        Object.keys(p).forEach(serviceId => {
          s.customMetadata[serviceId] = p[serviceId];
        });
      }
    }
  },
  actions: {
    async fetchSchema(context, {
      serviceId,
      entityId
    }) {
      // 查找已缓存的schema信息
      const schema = context.getters[GETTER.GET_ORIGIN_METADATA](serviceId, entityId);
      // 存在缓存数据的场合
      if (!_.isEmpty(schema)) {
        return schema;
      }
      // 从服务端取得指定服务的schema一览
      const response = await getSchemaByServiceId(serviceId);
      const {
        EntityContainer,
        EntityType
      } = response;
      // 转换entityContainer
      const entityContainerRes = transformEntityContainer(serviceId, EntityContainer);
      context.commit('updateEntityContainer', {
        serviceId,
        data: entityContainerRes
      });
      // 转换entityType
      const entityTypeRes = transformEntityTypeList(EntityType);
      // 保存原始转换结果
      context.commit('updateOriginMetadata', {
        serviceId,
        data: entityTypeRes
      });
      return response;
    },
    async [ACTION.FETCH_ENTITY](context, {
      serviceId,
      entityId
    }) {
      let needFetchEntityIdArray = null;
      const entityIdArray = Array.isArray(entityId) ? entityId : [entityId];
      // 查找已缓存的entity信息
      const {
        metadata
      } = context.state;
      const serviceObject = metadata[serviceId];
      // 对应服务的Entity没有缓存过的场合
      if (_.isEmpty(serviceObject)) {
        needFetchEntityIdArray = entityIdArray;
        metadata[serviceId] = {};
      } else {
        needFetchEntityIdArray = [];
        const cachedEntityIds = serviceObject;
        entityIdArray.forEach(id => {
          if (_.isEmpty(cachedEntityIds[id])) {
            needFetchEntityIdArray.push(id);
          }
        });
      }
      if (!_.isEmpty(needFetchEntityIdArray)) {
        // 获取原始schema信息
        await context.dispatch('fetchSchema', {
          serviceId,
          entityId
        });
        needFetchEntityIdArray.forEach(id => {
          const schema = context.getters[GETTER.GET_ORIGIN_METADATA](serviceId, id);
          const properties = _.get(schema, 'properties', []);
          const payload = {
            serviceId,
            entityId: id,
            entityProperties: properties
          };
          context.commit(MUTATION.UPDATE_ENTITY, payload);
        });
      }
      const ret = [];
      entityIdArray.forEach(id => {
        const tempMetadata = metadata;
        ret.push(tempMetadata[serviceId][id]);
      });
      return _.cloneDeep(ret);
    }
  }
};